module.exports = __webpack_public_path__ + "img/ky.5814c5a9.svg";